import { render, staticRenderFns } from "./ClientApiTestPage.vue?vue&type=template&id=28bf7bc0&scoped=true&"
import script from "./ClientApiTestPage.vue?vue&type=script&lang=js&"
export * from "./ClientApiTestPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientApiTestPage.vue?vue&type=style&index=0&id=28bf7bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf7bc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VProgressLinear,VRow})
